import type { SerializedStyles } from '@emotion/react'
import { css } from '@emotion/react'
import type { TRANSITION_CLASSNAMES } from '@oneToOne/shared/components/chat/constants'

import { TRANSITION_DURATION, TRANSITION_TIMING_FUNCTION } from '../styles'

type ValueOf<T> = T[keyof T]

interface generateTransitionGroupStylesParams {
  className: ValueOf<typeof TRANSITION_CLASSNAMES>
  startStyle: SerializedStyles
  endStyle: SerializedStyles
}

/**
 * Generates CSS transition styles for a hiding and showing transitions.
 */
export const generateTransitionGroupStyles = ({
  className,
  endStyle,
  startStyle,
}: generateTransitionGroupStylesParams) => {
  return css`
    .${className}-enter {
      ${startStyle}
    }

    .${className}-enter-active {
      transition: all ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};

      ${endStyle}
    }

    .${className}-exit {
      ${endStyle}
    }

    .${className}-exit-active {
      transition: all ${TRANSITION_DURATION} ${TRANSITION_TIMING_FUNCTION};

      ${startStyle}
    }
  `
}
